import React, { forwardRef } from 'react';
import classNames from 'classnames';

import * as styles from './index.module.scss';

export const SeoHtml = forwardRef(({ html, className }, ref) => (
  <div
    ref={ref}
    className={classNames(styles.html, className)}
    dangerouslySetInnerHTML={{ __html: html }}
  />
));

SeoHtml.displayName = 'SeoHtml';
